export default {
  /**
 * 对象转换成url
 * @param {*} obj
 */
  obj2url (obj) {
    return `?${ Object.entries(obj).map(([key, val]) => `${key}=${val}`).join('&')}`;
  }
};



// WEBPACK FOOTER //
// ./src/service/stringUtil.js